import ExecutionHistory from "../pages/Rules/ExecutionHistory";
import { Route, Navigate } from "react-router-dom";
import Resource from "../pages/Resource/Resource";
import AddResource from "../pages/Resource/AddResource";
import Domain from "../pages/Domain/Domain";
import AddDomain from "../pages/Domain/AddDomain";
import FileList from "../pages/FileList";
import AddRule from "../pages/Rules/AddRule";
import EditRule from "../pages/Rules/EditRule";
import ViewRule from "../pages/Rules/ViewRule";
import RulesList from "../pages/Rules/RulesList";
import RuleHistory from "../pages/Rules/RuleHistory";

import AddResourceColumnDetails from "../pages/ResourceColumns/AddResourceColumnDetails";
import ViewResource from "../pages/Resource/ViewResource";
import EditResource from "../pages/Resource/EditResource";
import ViewDomain from "../pages/Domain/ViewDomain";
import EditDomain from "../pages/Domain/EditDomain";
import RuleExecution from "../pages/Rules/RuleExecution";
import ValidateResource from "../pages/Resource/ValidateResource";
import ValidationResult from "../pages/Resource/ValidationResult";
import ConsolidateResults from "../pages/Results/ConsolidateResults";
import ValidationExecutionResults from "../pages/Results/ValidationExecutionResults";
import ValidationHistory from "../pages/Results/ValidationHistory";
import { ResourceProvider } from "../contexts/ResourceContext";
import ResourceColumns from "../pages/ResourceColumns/ResourceColumns";
import ViewResourceColumn from "../pages/ResourceColumns/ViewResourceColumn";
import EditResourceColumn from "../pages/ResourceColumns/EditResourceColumn";
import AddLinkedServices from "../pages/LinkedServices/AddLinkedServices";
import LinkedServices from "../pages/LinkedServices/LinkedServices";
import ViewLinkedServices from "../pages/LinkedServices/ViewLinkedServices";
import ConnectionKeys from "../pages/ConnectionKeys/ConnectionKeys";
import AddConnectionKey from "../pages/ConnectionKeys/AddEditConnectionKey";
import ViewConnectionKey from "../pages/ConnectionKeys/ViewConnectionKey";
import RunInstance from "../pages/Run Instance/RunInstance";
import AddEditRunInstance from "../pages/Run Instance/AddEditRunInstance";
import ViewRunInstance from "../pages/Run Instance/ViewRunInstance";
import ExecutionSubGroup from "../pages/ExecutionSubGroup/ExecutionSubGroup";
import AddEditExecutionSubGroup from "../pages/ExecutionSubGroup/AddEditExecutionSubGroup";
import ViewExecutionSubGroup from "../pages/ExecutionSubGroup/ViewExecutionSubGroup";
import ComparisonResearchQueries from "../pages/ComparisonResearchQueries/ComparisonResearchQueries";
import AuditComparison from "../pages/ComparisonResearchQueries/AuditComparison";
import FileProcessingAttributes from "../components/FileProcessingAttributes/FileProcessingAttributes";
import AddEditFileProcessingAttributes from "../components/FileProcessingAttributes/AddEditFileProcessingAttributes";
import ViewFileProcessingAttributes from "../components/FileProcessingAttributes/ViewFileProcessingAttributes";
import { RuleProvider } from "../contexts/RuleContext";
import { RuleResourceProvider } from "../contexts/RuleResourceContext";
import { TagAndSystemProvider } from "../contexts/TagAndSystemProvider";
import { ClassificationProvider } from "../contexts/ClassificationContext";
import AuditResource from "../pages/Resource/AuditResource";
import AuditResourceColumn from "../pages/ResourceColumns/AuditResourceColumn";
import AuditDomain from "../pages/Domain/AuditDomain";
import AuditRule from "../pages/Results/AuditRule";
import ImportJson from "../components/ImportJson/ImportJson";
import ResourceResearchQuery from "../pages/Resource/ResourceResearchQuery";
import RuleResearchQuery from "../pages/Rules/RuleResearchQuery";
import AuditConnectionKey from "../pages/ConnectionKeys/AuditConnectionKey";
import AuditLinkedServices from "../pages/LinkedServices/AuditLinkedServices";
import AdminPages from "../pages/AdminPages";
import BlobList from "../pages/BlobLists/BlobList";
import SftpList from "../pages/SftpLists/SftpList";
import ComparisonResultDashboard from "../pages/Rules/ComparisonResultDashboard";
import DomainLinkage from "../pages/DomainLinkage/DomainLinkage";
import AddEditDomainLinkage from "../pages/DomainLinkage/AddEditDomainLinkage";
import IncidentReportingReRun from "../pages/Rules/IncidentReportingReRun";
import IncidentReportingReRunReport from "../pages/Rules/IncidentReportingReRunReport";
import AllIssueList from "../pages/Issues/AllIssueList";
import ReRunValidateResource from "../pages/Resource/ReRun/ReRunValidateResource";
import ReRunRuleExecution from "../pages/Rules/Rerun/ReRunRuleExecution";
import ViewDomainLinkage from "../pages/DomainLinkage/ViewDomainLinkage";
import ConnectionRuntimeConfigList from "../pages/ConnectionRuntimeConfig/ConnectionRuntimeConfigList";
import AddEditConnectionRuntimeConfig from "../pages/ConnectionRuntimeConfig/AddEditConnectionRuntimeConfig";
import ViewConnectionRuntimeConfig from "../pages/ConnectionRuntimeConfig/ViewConnectionRuntimeConfig";

import GenericResearchQuery from "../pages/ResearchQuery/GenericResearchQuery";
import GenericResearchQueryList from "../pages/ResearchQuery/GenericResearchQueryList";
import ResearchQueryExecution from "../pages/ResearchQuery/ResearchQueryExecution";
import GenericResultDashboard from "../pages/ResearchQuery/GenericResultDashboard";
import GenericResearchExecutionHistory from "../pages/ResearchQuery/GenericResearchExecutionHistory";
import ReRunResearchQueryExecution from "../pages/ResearchQuery/ReRun/ReRunResearchQueryExecution";
import AuditGenericResearchQuery from "../pages/ResearchQuery/AuditGenericResearchQuery";
import SystemList from "../pages/System/SystemList";
import AddEditSystem from "../pages/System/AddEditSystem";
import ViewSystem from "../pages/System/ViewSystem";
import ClassificationList from "../pages/Classification/ClassificationList";
import AddEditClassification from "../pages/Classification/AddEditClassification";
import ViewClassification from "../pages/Classification/ViewClassification";
import ReasonList from "../pages/Reason/ReasonList";
import AddEditReason from "../pages/Reason/AddEditReason";
import ViewReason from "../pages/Reason/ViewReason";
import Users from "../pages/Users/Users";
import Profile from "../pages/Profile/Profile";
import ChangePassword from "../pages/Profile/ChangePassword";
import EditUser from "../pages/Users/EditUser";
import ViewUser from "../pages/Users/ViewUser";
import Roles from "../pages/Roles/Roles";
import AddEditRole from "../pages/Roles/AddEditRole";
import ViewRole from "../pages/Roles/ViewRole";
import Groups from "../pages/Groups/Groups";
import AddEditGroup from "../pages/Groups/AddEditGroup";
import ViewGroup from "../pages/Groups/ViewGroup";
import AssignUsers from "../pages/Groups/AssignUsers";
import AuthTags from "../pages/AuthTags/AuthTags";
import AddEditAuthTag from "../pages/AuthTags/AddEditAuthTag";
import ViewAuthTag from "../pages/AuthTags/ViewAuthTag";
import DashboardEmbed from "../pages/Dashboard/DashboardEmbed";
import DashboardEmbedV2 from "../pages/Dashboard/DashboardEmbedV2";

import Forbidden403 from "../pages/Errors/Forbidden403";
import { ProtectedRoute } from "../components/RouteProtection";
import ScoringConfig from "../pages/Scoring/ScoringConfig";
import ScoringDefaults from "../pages/Scoring/ScoringDefaults";
// Standalone *List components are rendered inside ScoringConfig's tabs, not as
// top-level routes. Legacy /scoring/<entity> URLs now redirect into
// /scoring-config?tab=…&{run|agg}Sub=… (see Navigate redirects below).
import AddEditValidationScoring from "../pages/Scoring/AddEditValidationScoring";
import ViewValidationScoring from "../pages/Scoring/ViewValidationScoring";
import AuditValidationScoring from "../pages/Scoring/AuditValidationScoring";
import AddEditComparisonScoring from "../pages/Scoring/AddEditComparisonScoring";
import ViewComparisonScoring from "../pages/Scoring/ViewComparisonScoring";
import AuditComparisonScoring from "../pages/Scoring/AuditComparisonScoring";
import AddEditComparisonRunScoring from "../pages/Scoring/AddEditComparisonRunScoring";
import ViewComparisonRunScoring from "../pages/Scoring/ViewComparisonRunScoring";
import AddEditResearchQueryRunScoring from "../pages/Scoring/AddEditResearchQueryRunScoring";
import ViewResearchQueryRunScoring from "../pages/Scoring/ViewResearchQueryRunScoring";
import AddEditGenericRQScoring from "../pages/Scoring/AddEditGenericRQScoring";
import ViewGenericRQScoring from "../pages/Scoring/ViewGenericRQScoring";
import AuditGenericRQScoring from "../pages/Scoring/AuditGenericRQScoring";
import RunScoringDetailedOverview from "../pages/Scoring/RunScoringDetailedOverview";
import AddEditValidationRunScoring from "../pages/Scoring/AddEditValidationRunScoring";
import ViewValidationRunScoring from "../pages/Scoring/ViewValidationRunScoring";
import AuditValidationRunScoring from "../pages/Scoring/AuditValidationRunScoring";
import AddEditPipelineWeightConfig from "../pages/Scoring/AddEditPipelineWeightConfig";
import ViewPipelineWeightConfig from "../pages/Scoring/ViewPipelineWeightConfig";
import RunScoreHistory from "../pages/Results/RunScoreHistory";
import AggregatedScoreDashboard from "../pages/Results/AggregatedScoreDashboard";
const ProtectedRoutes = () => {
  return (
    <>
      {/* domain routes start */}
      <Route
        path="domain"
        element={
          <TagAndSystemProvider>
            <Domain />
          </TagAndSystemProvider>
        }
      />
      <Route
        path="domain/add"
        element={
          <ProtectedRoute entity="domain" action="add">
            <TagAndSystemProvider>
              <AddDomain />
            </TagAndSystemProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="domain/view/:id"
        element={
          <ProtectedRoute entity="domain" action="view">
            <TagAndSystemProvider>
              <ViewDomain />
            </TagAndSystemProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="domain/edit/:id"
        element={
          <ProtectedRoute entity="domain" action="edit">
            <TagAndSystemProvider>
              <EditDomain />
            </TagAndSystemProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="domain/auditDomain/:id"
        element={
          <ProtectedRoute entity="domain" action="view">
            <AuditDomain />
          </ProtectedRoute>
        }
      />
      <Route path="domain-linkage" element={<DomainLinkage />} />
      <Route
        path="domain-linkage/add"
        element={
          <ProtectedRoute entity="domain_linkage" action="add">
            <TagAndSystemProvider>
              <AddEditDomainLinkage />
            </TagAndSystemProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="domain-linkage/edit/:id"
        element={
          <ProtectedRoute entity="domain_linkage" action="edit">
            <TagAndSystemProvider>
              <AddEditDomainLinkage />
            </TagAndSystemProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="domain-linkage/view/:id"
        element={
          <ProtectedRoute entity="domain_linkage" action="view">
            <TagAndSystemProvider>
              <ViewDomainLinkage />
            </TagAndSystemProvider>
          </ProtectedRoute>
        }
      />
      {/* domain routes end */}
      {/* resource routes starts */}
      <Route
        path="resource/:domainId?"
        element={
          <TagAndSystemProvider>
            <Resource />
          </TagAndSystemProvider>
        }
      />
      <Route
        path="resource/add/:domainId?"
        element={
          <ProtectedRoute entity="resource" action="add">
            <RuleResourceProvider>
              <ResourceProvider>
                <TagAndSystemProvider>
                  <AddResource />
                </TagAndSystemProvider>
              </ResourceProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="resource/:domainId/view/:id"
        element={
          <ProtectedRoute entity="resource" action="view">
            <RuleResourceProvider>
              <ResourceProvider>
                <TagAndSystemProvider>
                  <ViewResource />
                </TagAndSystemProvider>
              </ResourceProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="resource/:domainId/researchQuery/:id"
        element={
          <ProtectedRoute entity="resource" action="view">
            <RuleResourceProvider>
              <ResourceProvider>
                <ResourceResearchQuery />
              </ResourceProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      {/* // indvisual research query started here  */}
      <Route
        path="research-query"
        element={
          <RuleResourceProvider>
            <ResourceProvider>
              <TagAndSystemProvider>
                <GenericResearchQueryList />
              </TagAndSystemProvider>
            </ResourceProvider>
          </RuleResourceProvider>
        }
      />
      <Route
        path="research-query/view/:id"
        element={
          <ProtectedRoute entity="generic_research_query" action="view">
            <RuleResourceProvider>
              <ResourceProvider>
                <TagAndSystemProvider>
                  <GenericResearchQuery isViewOnly={true} />
                </TagAndSystemProvider>
              </ResourceProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="research-query/edit/:id"
        element={
          <ProtectedRoute entity="generic_research_query" action="edit">
            <RuleResourceProvider>
              <ResourceProvider>
                <TagAndSystemProvider>
                  <GenericResearchQuery />
                </TagAndSystemProvider>
              </ResourceProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="research-query/auditGenericResearchQuery/:id"
        element={
          <ProtectedRoute entity="generic_research_query" action="view">
            <AuditGenericResearchQuery />
          </ProtectedRoute>
        }
      />
      <Route
        path="research-query/add"
        element={
          <ProtectedRoute entity="generic_research_query" action="add">
            <RuleResourceProvider>
              <ResourceProvider>
                <TagAndSystemProvider>
                  <GenericResearchQuery />
                </TagAndSystemProvider>
              </ResourceProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="research-execution-history"
        element={
          <TagAndSystemProvider>
            <GenericResearchExecutionHistory />
          </TagAndSystemProvider>
        }
      />
      <Route
        path="research-execution-history/:researchQueryId/:execution_id/dashboard"
        element={
          <ProtectedRoute entity="generic_research_query_result" action="view">
            <RuleResourceProvider>
              <ResourceProvider>
                <ClassificationProvider>
                  <GenericResultDashboard />
                </ClassificationProvider>
              </ResourceProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="resource/:domainId/edit/:id"
        element={
          <ProtectedRoute entity="resource" action="edit">
            <RuleResourceProvider>
              <ResourceProvider>
                <TagAndSystemProvider>
                  <EditResource />
                </TagAndSystemProvider>
              </ResourceProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="research-query/research-query-execution/:id"
        element={
          <ProtectedRoute entity="generic_research_query" action="execute">
            <RuleResourceProvider>
              <ResourceProvider>
                <TagAndSystemProvider>
                  <ResearchQueryExecution />
                </TagAndSystemProvider>
              </ResourceProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="research-execution-history/re-run-research-query-execution/:id"
        element={
          <ProtectedRoute entity="generic_research_query" action="execute">
            <RuleResourceProvider>
              <ResourceProvider>
                <TagAndSystemProvider>
                  <ReRunResearchQueryExecution />
                </TagAndSystemProvider>
              </ResourceProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="resource/:domainId/auditResource/:id"
        element={
          <ProtectedRoute entity="resource" action="view">
            <AuditResource />
          </ProtectedRoute>
        }
      />
      <Route
        path="resource/:domainId/validate-result"
        element={<ValidationResult />}
      />
      <Route
        path="resource/:domainId/validate-resource/:id"
        element={
          <ProtectedRoute entity="resource" action="validate">
            <RuleResourceProvider>
              <ResourceProvider>
                <TagAndSystemProvider>
                  <ValidateResource />
                </TagAndSystemProvider>
              </ResourceProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="resource/:domainId/re-run-validate-resource/:id"
        element={
          <ProtectedRoute entity="resource" action="validate">
            <RuleResourceProvider>
              <ResourceProvider>
                <TagAndSystemProvider>
                  <ReRunValidateResource />
                </TagAndSystemProvider>
              </ResourceProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      {/* resource routes end */}

      {/* resource columns routes start */}
      <Route
        path="resource-columns/:domainId"
        element={
          <ProtectedRoute entity="resource_column_details" action="view">
            <ResourceProvider>
              <ResourceColumns />
            </ResourceProvider>
          </ProtectedRoute>
        }
      />

      <Route
        path="resource-columns/add-columns"
        element={
          <ProtectedRoute entity="resource_column_details" action="add">
            <RuleResourceProvider>
              <ResourceProvider>
                <TagAndSystemProvider>
                  <AddResourceColumnDetails />
                </TagAndSystemProvider>
              </ResourceProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="resource-columns/:domainId/view/:id"
        element={
          <ProtectedRoute entity="resource_column_details" action="view">
            <RuleResourceProvider>
              <ResourceProvider>
                <TagAndSystemProvider>
                  <ViewResourceColumn />
                </TagAndSystemProvider>
              </ResourceProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="resource-columns/:domainId/edit/:id"
        element={
          <ProtectedRoute entity="resource_column_details" action="edit">
            <RuleResourceProvider>
              <ResourceProvider>
                <TagAndSystemProvider>
                  <EditResourceColumn />
                </TagAndSystemProvider>
              </ResourceProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="resource-columns/:domainId/auditResourceColumn/:id"
        element={
          <ProtectedRoute entity="resource_column_details" action="view">
            <ResourceProvider>
              <AuditResourceColumn />
            </ResourceProvider>
          </ProtectedRoute>
        }
      />

      {/* resource column routes end */}

      {/* rules routes starts */}
      <Route
        path="rules-list/:domainId?"
        element={
          <RuleProvider>
            <TagAndSystemProvider>
              <RulesList />
            </TagAndSystemProvider>
          </RuleProvider>
        }
      />
      <Route
        path="rules/add"
        element={
          <ProtectedRoute entity="rule" action="add">
            <RuleResourceProvider>
              <RuleProvider>
                <TagAndSystemProvider>
                  <AddRule />
                </TagAndSystemProvider>
              </RuleProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="rules/:domainId/edit/:id"
        element={
          <ProtectedRoute entity="rule" action="edit">
            <RuleResourceProvider>
              <RuleProvider>
                <TagAndSystemProvider>
                  <EditRule />
                </TagAndSystemProvider>
              </RuleProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="rules/:domainId/view/:id"
        element={
          <ProtectedRoute entity="rule" action="view">
            <RuleResourceProvider>
              <RuleProvider>
                <TagAndSystemProvider>
                  <ViewRule />
                </TagAndSystemProvider>
              </RuleProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="rules/:domainId/researchQuery/:id"
        element={
          <ProtectedRoute entity="comparison_research_query" action="view">
            <RuleResourceProvider>
              <RuleProvider>
                <ResourceProvider>
                  <TagAndSystemProvider>
                    <RuleResearchQuery />
                  </TagAndSystemProvider>
                </ResourceProvider>
              </RuleProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />

      <Route
        path="rules/:domainId/rule-execution/:ruleId"
        element={
          <ProtectedRoute entity="rule" action="execute">
            <RuleProvider>
              <RuleResourceProvider>
                <ResourceProvider>
                  <TagAndSystemProvider>
                    <RuleExecution />
                  </TagAndSystemProvider>
                </ResourceProvider>
              </RuleResourceProvider>
            </RuleProvider>
          </ProtectedRoute>
        }
      />

      <Route
        path="rules/:domainId/re-run-rule-execution/:ruleId"
        element={
          <ProtectedRoute entity="rule" action="execute">
            <RuleProvider>
              <RuleResourceProvider>
                <ResourceProvider>
                  <TagAndSystemProvider>
                    <ReRunRuleExecution />
                  </TagAndSystemProvider>
                </ResourceProvider>
              </RuleResourceProvider>
            </RuleProvider>
          </ProtectedRoute>
        }
      />

      <Route
        path="rules/:domainId/auditRule/:id"
        element={
          <ProtectedRoute entity="rule" action="view">
            <ResourceProvider>
              <AuditRule />
            </ResourceProvider>
          </ProtectedRoute>
        }
      />

      {/* rules routes ends */}

      {/* rule execution history routes start */}
      <Route path="rules-execution-history" element={<ExecutionHistory />} />
      <Route
        path="rules-execution-history/:id/:ruleResultId/dashboard"
        element={
          <ProtectedRoute entity="rule_result" action="view">
            <ClassificationProvider>
              <ComparisonResultDashboard />
            </ClassificationProvider>
          </ProtectedRoute>
        }
      />

      <Route
        path="incident-reporting-rerun"
        element={<IncidentReportingReRun />}
      />
      <Route
        path="incident-reporting-rerun-report"
        element={<IncidentReportingReRunReport />}
      />

      <Route
        path="rules-execution-history/consolidate-results"
        element={<ConsolidateResults />}
      />
      {/* rule execution history routes end */}

      {/* validation execution history routes start */}
      <Route
        path="validation-execution-history/validate-result/:resourceResultId"
        element={
          <ProtectedRoute entity="validation_result" action="view">
            <ClassificationProvider>
              <ValidationResult />
            </ClassificationProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="validation-execution-history/validation-execution-results"
        element={<ValidationExecutionResults />}
      />
      <Route
        path="validation-execution-history"
        element={
          <TagAndSystemProvider>
            <ValidationHistory />
          </TagAndSystemProvider>
        }
      />
      {/* validation execution history routes end */}

      <Route path="files-list" element={<FileList />} />

      <Route path="rule-history" element={<RuleHistory />} />

      {/* <Route
        path="dashboard"
        element={
          <PowerBIReport
            accessToken="<YOUR_EMBED_TOKEN>"
            embedUrl="https://app.powerbi.com/view?r=eyJrIjoiOGZjZTNjZDctODE2NS00NjJhLTk4OGItZGMyOGUzODhjODg4IiwidCI6IjNlMzdlZDZlLTg2ZDYtNGM5OC1hOGYxLTI2YWI1ZWM1NWQwMiIsImMiOjN9"
            reportId="d3480017-c93a-4948-9ae5-b8c26825ae26"
            tokenType="Embed"
          />
        }
      /> */}

      {/* <Route path="dashboard" element={<Home />} /> */}
      <Route path="dashboard" element={<DashboardEmbed />} />
      <Route path="dashboard-v2" element={<DashboardEmbedV2 />} />

      <Route path="linked-services" element={<LinkedServices />} />
      <Route
        path="linked-services/add"
        element={
          <ProtectedRoute entity="linked_service" action="add">
            <TagAndSystemProvider>
              <AddLinkedServices />
            </TagAndSystemProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="linked-services/view/:id"
        element={
          <ProtectedRoute entity="linked_service" action="view">
            <ViewLinkedServices />
          </ProtectedRoute>
        }
      />
      <Route
        path="linked-services/edit/:id"
        element={
          <ProtectedRoute entity="linked_service" action="edit">
            <TagAndSystemProvider>
              <AddLinkedServices />
            </TagAndSystemProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="connection-keys"
        element={
          <TagAndSystemProvider>
            <ConnectionKeys />
          </TagAndSystemProvider>
        }
      />
      <Route
        path="connection-keys/add"
        element={
          <ProtectedRoute entity="connection_key" action="add">
            <TagAndSystemProvider>
              <AddConnectionKey />
            </TagAndSystemProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="connection-keys/edit/:id"
        element={
          <ProtectedRoute entity="connection_key" action="edit">
            <TagAndSystemProvider>
              <AddConnectionKey />
            </TagAndSystemProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="connection-keys/view/:id"
        element={
          <ProtectedRoute entity="connection_key" action="view">
            <TagAndSystemProvider>
              <ViewConnectionKey />
            </TagAndSystemProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="connection-keys/auditConnectionKey/:id"
        element={
          <ProtectedRoute entity="connection_key" action="view">
            <AuditConnectionKey />
          </ProtectedRoute>
        }
      />

      <Route
        path="run-instance"
        element={
          <ProtectedRoute entity="run_instance" action="view">
            <RunInstance />
          </ProtectedRoute>
        }
      />
      <Route
        path="run-instance/add"
        element={
          <ProtectedRoute entity="run_instance" action="add">
            <AddEditRunInstance />
          </ProtectedRoute>
        }
      />
      <Route
        path="run-instance/view/:id"
        element={
          <ProtectedRoute entity="run_instance" action="view">
            <ViewRunInstance />
          </ProtectedRoute>
        }
      />
      <Route
        path="run-instance/edit/:id"
        element={
          <ProtectedRoute entity="run_instance" action="edit">
            <AddEditRunInstance />
          </ProtectedRoute>
        }
      />

      <Route
        path="execution-sub-group"
        element={
          <ProtectedRoute entity="execution_sub_group" action="view">
            <ExecutionSubGroup />
          </ProtectedRoute>
        }
      />
      <Route
        path="execution-sub-group/add"
        element={
          <ProtectedRoute entity="execution_sub_group" action="add">
            <AddEditExecutionSubGroup />
          </ProtectedRoute>
        }
      />
      <Route
        path="execution-sub-group/view/:id"
        element={
          <ProtectedRoute entity="execution_sub_group" action="view">
            <ViewExecutionSubGroup />
          </ProtectedRoute>
        }
      />
      <Route
        path="execution-sub-group/edit/:id"
        element={
          <ProtectedRoute entity="execution_sub_group" action="edit">
            <AddEditExecutionSubGroup />
          </ProtectedRoute>
        }
      />
      {/* comparison research queries routes start */}
      <Route
        path="comparison-research-queries"
        element={
          <ProtectedRoute entity="comparison_research_query" action="view">
            <TagAndSystemProvider>
              <ComparisonResearchQueries />
            </TagAndSystemProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="comparison-research-queries/view/:id"
        element={
          <ProtectedRoute entity="comparison_research_query" action="view">
            <RuleResourceProvider>
              <RuleProvider>
                <ResourceProvider>
                  <TagAndSystemProvider>
                    <RuleResearchQuery isViewOnly={true} />
                  </TagAndSystemProvider>
                </ResourceProvider>
              </RuleProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="comparison-research-queries/manage"
        element={
          <ProtectedRoute entity="comparison_research_query" action="add">
            <RuleResourceProvider>
              <RuleProvider>
                <ResourceProvider>
                  <TagAndSystemProvider>
                    <RuleResearchQuery />
                  </TagAndSystemProvider>
                </ResourceProvider>
              </RuleProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="comparison-research-queries/edit/:id"
        element={
          <ProtectedRoute entity="comparison_research_query" action="edit">
            <RuleResourceProvider>
              <RuleProvider>
                <ResourceProvider>
                  <TagAndSystemProvider>
                    <RuleResearchQuery />
                  </TagAndSystemProvider>
                </ResourceProvider>
              </RuleProvider>
            </RuleResourceProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="comparison-research-queries/auditComparison/:id"
        element={
          <ProtectedRoute entity="comparison_research_query" action="view">
            <AuditComparison />
          </ProtectedRoute>
        }
      />

      {/* connection runtime config routes start */}
      <Route
        path="connection-runtime-config"
        element={<ConnectionRuntimeConfigList />}
      />
      <Route
        path="connection-runtime-config/add"
        element={
          <ProtectedRoute entity="connection_runtime_config" action="add">
            <AddEditConnectionRuntimeConfig />
          </ProtectedRoute>
        }
      />
      <Route
        path="connection-runtime-config/view/:id"
        element={
          <ProtectedRoute entity="connection_runtime_config" action="view">
            <ViewConnectionRuntimeConfig />
          </ProtectedRoute>
        }
      />
      <Route
        path="connection-runtime-config/edit/:id"
        element={
          <ProtectedRoute entity="connection_runtime_config" action="edit">
            <AddEditConnectionRuntimeConfig />
          </ProtectedRoute>
        }
      />
      {/* system routes start */}
      <Route path="system" element={<SystemList />} />
      <Route
        path="system/add"
        element={
          <ProtectedRoute entity="system" action="add">
            <AddEditSystem />
          </ProtectedRoute>
        }
      />
      <Route
        path="system/view/:id"
        element={
          <ProtectedRoute entity="system" action="view">
            <TagAndSystemProvider>
              <ViewSystem />
            </TagAndSystemProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="system/edit/:id"
        element={
          <ProtectedRoute entity="system" action="edit">
            <AddEditSystem />
          </ProtectedRoute>
        }
      />
      {/* system routes end */}
      {/* classification routes start */}
      <Route path="classification" element={<ClassificationList />} />
      <Route
        path="classification/add"
        element={
          <ProtectedRoute entity="classification" action="add">
            <AddEditClassification />
          </ProtectedRoute>
        }
      />
      <Route
        path="classification/view/:id"
        element={
          <ProtectedRoute entity="classification" action="view">
            <ViewClassification />
          </ProtectedRoute>
        }
      />
      <Route
        path="classification/edit/:id"
        element={
          <ProtectedRoute entity="classification" action="edit">
            <AddEditClassification />
          </ProtectedRoute>
        }
      />
      {/* classification routes end */}
      {/* reason routes start */}
      <Route path="reason" element={<ReasonList />} />
      <Route
        path="reason/add"
        element={
          <ProtectedRoute entity="reason" action="add">
            <AddEditReason />
          </ProtectedRoute>
        }
      />
      <Route
        path="reason/view/:id"
        element={
          <ProtectedRoute entity="reason" action="view">
            <ViewReason />
          </ProtectedRoute>
        }
      />
      <Route
        path="reason/edit/:id"
        element={
          <ProtectedRoute entity="reason" action="edit">
            <AddEditReason />
          </ProtectedRoute>
        }
      />
      {/* reason routes end */}
      <Route
        path="file-processing-attributes"
        element={<FileProcessingAttributes />}
      />
      <Route
        path="file-processing-attributes/add"
        element={
          <ProtectedRoute entity="file_processing_attributes" action="add">
            <AddEditFileProcessingAttributes />
          </ProtectedRoute>
        }
      />
      <Route
        path="file-processing-attributes/view/:id"
        element={
          <ProtectedRoute entity="file_processing_attributes" action="view">
            <ViewFileProcessingAttributes />
          </ProtectedRoute>
        }
      />
      <Route
        path="file-processing-attributes/edit/:id"
        element={
          <ProtectedRoute entity="file_processing_attributes" action="edit">
            <AddEditFileProcessingAttributes />
          </ProtectedRoute>
        }
      />
      <Route path="domain/import-entity" element={<ImportJson />} />
      <Route path="resource/import-entity" element={<ImportJson />} />
      <Route path="resource-column/import-entity" element={<ImportJson />} />
      <Route path="rules/import-entity" element={<ImportJson />} />
      <Route
        path="file-processing-attributes/import-entity"
        element={<ImportJson />}
      />
      <Route path="connection-keys/import-entity" element={<ImportJson />} />
      <Route path="linked-services/import-entity" element={<ImportJson />} />
      <Route path="run-instance/import-entity" element={<ImportJson />} />
      <Route path="research-query/import-entity" element={<ImportJson />} />
      <Route
        path="comparison-research-queries/import-entity"
        element={<ImportJson />}
      />
      <Route
        path="linked-services/auditLinkedServices/:id"
        element={<AuditLinkedServices />}
      />
      <Route
        path="blob-list"
        element={
          <ProtectedRoute entity="blob_list" action="view">
            <BlobList />
          </ProtectedRoute>
        }
      />
      <Route
        path="sftp-list"
        element={
          <ProtectedRoute entity="sftp_list" action="view">
            <SftpList />
          </ProtectedRoute>
        }
      />
      <Route
        path="admin"
        element={
          <ProtectedRoute adminOnly={true}>
            <AdminPages />
          </ProtectedRoute>
        }
      />

      {/* User Management Routes */}
      <Route path="users" element={<Users />} />
      <Route
        path="users/edit/:id"
        element={
          <ProtectedRoute entity="user" action="edit">
            <EditUser />
          </ProtectedRoute>
        }
      />
      <Route
        path="users/view/:id"
        element={
          <ProtectedRoute entity="user" action="view">
            <ViewUser />
          </ProtectedRoute>
        }
      />

      {/* Role Management Routes */}
      <Route path="roles" element={<Roles />} />
      <Route
        path="roles/add"
        element={
          <ProtectedRoute entity="user_role" action="add">
            <AddEditRole />
          </ProtectedRoute>
        }
      />
      <Route
        path="roles/edit/:id"
        element={
          <ProtectedRoute entity="user_role" action="edit">
            <AddEditRole />
          </ProtectedRoute>
        }
      />
      <Route
        path="roles/view/:id"
        element={
          <ProtectedRoute entity="user_role" action="view">
            <ViewRole />
          </ProtectedRoute>
        }
      />

      {/* Group Management Routes */}
      <Route path="groups" element={<Groups />} />
      <Route
        path="groups/add"
        element={
          <ProtectedRoute entity="user_group" action="add">
            <AddEditGroup />
          </ProtectedRoute>
        }
      />
      <Route
        path="groups/edit/:id"
        element={
          <ProtectedRoute entity="user_group" action="edit">
            <AddEditGroup />
          </ProtectedRoute>
        }
      />
      <Route
        path="groups/view/:id"
        element={
          <ProtectedRoute entity="user_group" action="view">
            <ViewGroup />
          </ProtectedRoute>
        }
      />
      <Route
        path="groups/:id/assign-users"
        element={
          <ProtectedRoute entity="user_group_users" action="view">
            <AssignUsers />
          </ProtectedRoute>
        }
      />

      {/* AuthTag Management Routes */}
      <Route path="tags" element={<AuthTags />} />
      <Route
        path="tags/add"
        element={
          <ProtectedRoute entity="auth_tag" action="add">
            <AddEditAuthTag />
          </ProtectedRoute>
        }
      />
      <Route
        path="tags/edit/:id"
        element={
          <ProtectedRoute entity="auth_tag" action="edit">
            <AddEditAuthTag />
          </ProtectedRoute>
        }
      />
      <Route
        path="tags/view/:id"
        element={
          <ProtectedRoute entity="auth_tag" action="view">
            <ViewAuthTag />
          </ProtectedRoute>
        }
      />

      {/* Mockups */}
      <Route
        path="issue-list"
        element={
          <ClassificationProvider>
            <TagAndSystemProvider>
              <AllIssueList />
            </TagAndSystemProvider>
          </ClassificationProvider>
        }
      />

      {/* Error Routes */}
      <Route path="403" element={<Forbidden403 />} />
      <Route
        path="validations-issue-list"
        element={
          <ClassificationProvider>
            <TagAndSystemProvider>
              <AllIssueList />
            </TagAndSystemProvider>
          </ClassificationProvider>
        }
      />

      {/* Scoring (legacy) */}
      <Route path="scoring-config" element={<ScoringConfig />} />
      <Route path="scoring-defaults" element={<ScoringDefaults />} />

      {/* Validation Scoring Routes
          List view is consolidated into /scoring-config; redirect legacy URL. */}
      <Route
        path="scoring/validation"
        element={<Navigate to="/scoring-config?tab=0&runSub=0" replace />}
      />
      <Route
        path="scoring/validation/add"
        element={
          <ProtectedRoute entity="validation_scoring_config" action="add">
            <AddEditValidationScoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/validation/edit/:id"
        element={
          <ProtectedRoute entity="validation_scoring_config" action="edit">
            <AddEditValidationScoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/validation/view/:id"
        element={
          <ProtectedRoute entity="validation_scoring_config" action="view">
            <ViewValidationScoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/validation/audit/:id"
        element={
          <ProtectedRoute entity="validation_scoring_config" action="view">
            <AuditValidationScoring />
          </ProtectedRoute>
        }
      />

      {/* Comparison Scoring Routes (legacy list URL → consolidated tabbed view) */}
      <Route
        path="scoring/comparison"
        element={<Navigate to="/scoring-config?tab=0&runSub=1" replace />}
      />
      <Route
        path="scoring/comparison/add"
        element={
          <ProtectedRoute entity="comparison_scoring_config" action="add">
            <AddEditComparisonScoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/comparison/edit/:id"
        element={
          <ProtectedRoute entity="comparison_scoring_config" action="edit">
            <AddEditComparisonScoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/comparison/view/:id"
        element={
          <ProtectedRoute entity="comparison_scoring_config" action="view">
            <ViewComparisonScoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/comparison/audit/:id"
        element={
          <ProtectedRoute entity="comparison_scoring_config" action="view">
            <AuditComparisonScoring />
          </ProtectedRoute>
        }
      />

      {/* Generic RQ Scoring Routes (legacy list URL → consolidated tabbed view) */}
      <Route
        path="scoring/generic-rq"
        element={<Navigate to="/scoring-config?tab=0&runSub=2" replace />}
      />
      <Route
        path="scoring/generic-rq/add"
        element={
          <ProtectedRoute
            entity="generic_research_query_scoring_config"
            action="add"
          >
            <AddEditGenericRQScoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/generic-rq/edit/:id"
        element={
          <ProtectedRoute
            entity="generic_research_query_scoring_config"
            action="edit"
          >
            <AddEditGenericRQScoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/generic-rq/view/:id"
        element={
          <ProtectedRoute
            entity="generic_research_query_scoring_config"
            action="view"
          >
            <ViewGenericRQScoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/generic-rq/audit/:id"
        element={
          <ProtectedRoute
            entity="generic_research_query_scoring_config"
            action="view"
          >
            <AuditGenericRQScoring />
          </ProtectedRoute>
        }
      />

      {/* Run Scoring Detailed Overview (cross-pipeline view) */}
      <Route
        path="scoring/run-overview/:runInstanceId"
        element={<RunScoringDetailedOverview />}
      />

      {/* Comparison Run Scoring Config Routes (legacy list URL → consolidated tabbed view) */}
      <Route
        path="scoring/comparison-run"
        element={<Navigate to="/scoring-config?tab=1&aggSub=1" replace />}
      />
      <Route
        path="scoring/comparison-run/add"
        element={
          <ProtectedRoute entity="comparison_run_scoring_config" action="add">
            <AddEditComparisonRunScoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/comparison-run/edit/:id"
        element={
          <ProtectedRoute entity="comparison_run_scoring_config" action="edit">
            <AddEditComparisonRunScoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/comparison-run/view/:id"
        element={
          <ProtectedRoute entity="comparison_run_scoring_config" action="view">
            <ViewComparisonRunScoring />
          </ProtectedRoute>
        }
      />

      {/* Validation Run Scoring Config Routes (legacy list URL → consolidated tabbed view) */}
      <Route
        path="scoring/validation-run"
        element={<Navigate to="/scoring-config?tab=1&aggSub=0" replace />}
      />
      <Route
        path="scoring/validation-run/add"
        element={
          <ProtectedRoute entity="validation_run_scoring_config" action="add">
            <AddEditValidationRunScoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/validation-run/edit/:id"
        element={
          <ProtectedRoute entity="validation_run_scoring_config" action="edit">
            <AddEditValidationRunScoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/validation-run/view/:id"
        element={
          <ProtectedRoute entity="validation_run_scoring_config" action="view">
            <ViewValidationRunScoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/validation-run/audit/:runId/:resourceId"
        element={
          <ProtectedRoute entity="validation_run_scoring_config" action="view">
            <AuditValidationRunScoring />
          </ProtectedRoute>
        }
      />

      {/* Research Query Run Scoring Config Routes (legacy list URL → consolidated tabbed view) */}
      <Route
        path="scoring/research-query-run"
        element={<Navigate to="/scoring-config?tab=1&aggSub=2" replace />}
      />
      <Route
        path="scoring/research-query-run/add"
        element={
          <ProtectedRoute
            entity="research_query_run_scoring_config"
            action="add"
          >
            <AddEditResearchQueryRunScoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/research-query-run/edit/:id"
        element={
          <ProtectedRoute
            entity="research_query_run_scoring_config"
            action="edit"
          >
            <AddEditResearchQueryRunScoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/research-query-run/view/:id"
        element={
          <ProtectedRoute
            entity="research_query_run_scoring_config"
            action="view"
          >
            <ViewResearchQueryRunScoring />
          </ProtectedRoute>
        }
      />

      {/* Pipeline Weight Config Routes (legacy list URL → consolidated tabbed view) */}
      <Route
        path="scoring/pipeline-weights"
        element={<Navigate to="/scoring-config?tab=1&aggSub=3" replace />}
      />
      <Route
        path="scoring/pipeline-weights/add"
        element={
          <ProtectedRoute entity="pipeline_weight_config" action="add">
            <AddEditPipelineWeightConfig />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/pipeline-weights/edit/:id"
        element={
          <ProtectedRoute entity="pipeline_weight_config" action="edit">
            <AddEditPipelineWeightConfig />
          </ProtectedRoute>
        }
      />
      <Route
        path="scoring/pipeline-weights/view/:id"
        element={
          <ProtectedRoute entity="pipeline_weight_config" action="view">
            <ViewPipelineWeightConfig />
          </ProtectedRoute>
        }
      />

      {/* Run Score History & Dashboard */}
      <Route path="results/run-score-history" element={<RunScoreHistory />} />
      <Route
        path="results/run-score-dashboard/:runId"
        element={<AggregatedScoreDashboard />}
      />

      {/* Profile */}
      <Route path="profile" element={<Profile />} />
      <Route path="profile/change-password" element={<ChangePassword />} />
    </>
  );
};

export default ProtectedRoutes;
